"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.default = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _history = require("history");
var _reactRedux = require("react-redux");
// Todo: we can change the history object to use a virtual history object in memory,
// which allows us to use chronobreak without relying on a browser (applications for instance).

// TODO: is there a way to implement a singleton hook?
let listener;

// TODO: change API to allow easier save functionality
const history = (0, _history.createBrowserHistory)();
const chronobreakResetState = (0, _toolkit.createAction)("chronobreakResetState");
const reduceChronobreakResetState = function (state, _ref) {
  let {
    payload
  } = _ref;
  return {
    ...payload
  };
};
const reducer = exports.reducer = (0, _toolkit.createReducer)({}, {
  [chronobreakResetState]: reduceChronobreakResetState
});
let previousLocation;
const useChronoBreak = function () {
  const store = (0, _reactRedux.useStore)();
  const dispatch = (0, _reactRedux.useDispatch)();

  // TODO: add to callback function to not regenerate this function
  const save = function () {
    let href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.pathname;
    let usePush = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const state = store.getState();
    // TODO: remove window reference
    // TODO: Is there a way to determine this without matching query vs location string? we have to match the syntax of the two, which isn't ideal
    const query = window.location.search + window.location.hash;
    if (query === href) {
      return;
    }
    if (usePush) {
      history.push(href, state);
    } else {
      history.replace(href, state);
    }
  };
  const closeOverlay = function () {
    // special implementation of save that reads previous value
    const query = previousLocation ? previousLocation.pathname + previousLocation.search + previousLocation.hash : undefined;
    save(query, true);
  };
  if (!listener) {
    listener = history.listen(function (_ref2) {
      let {
        location,
        action
      } = _ref2;
      if (action === "REPLACE") {
        previousLocation = location;
        return;
      }
      if (action !== "POP" || !(location !== null && location !== void 0 && location.state)) {
        return;
      }
      dispatch(chronobreakResetState({
        ...location.state
      }));
    });
  }
  return [save, closeOverlay];
};
var _default = exports.default = useChronoBreak;